import { AbsenceCategory } from "@myapp/contract";

const FULL_DAY_CATEGORIES: AbsenceCategory[] = ["SICK_LEAVE", "VACATION"];

export const isFullDayCategory = (category: AbsenceCategory): boolean =>
  FULL_DAY_CATEGORIES.includes(category);

/**
 * A `ScheduleEntry` is a half-open `[startsAt, endsAt)` range and the API refuses any span that is
 * not a whole number of minutes ("Der Zeitraum muss ein ganzzahliges Vielfaches einer Minute
 * sein"). So a full-day absence ends at local midnight of the day *after* the last absent day —
 * never at 23:59:59.999 of the last one, which is short of a full day by 1 ms and 400s.
 *
 * Both `Date`s are built from a bare `YYYY-MM-DDT00:00:00` string, i.e. parsed as local time, so
 * the resulting instants carry the user's UTC offset.
 */
export function fullDayRangeToIso(
  dateFrom: string,
  dateTo: string,
): { startsAt: string; endsAt: string } {
  const start = new Date(`${dateFrom}T00:00:00`);
  const endExclusive = new Date(`${dateTo}T00:00:00`);
  endExclusive.setDate(endExclusive.getDate() + 1);
  return { startsAt: start.toISOString(), endsAt: endExclusive.toISOString() };
}

/**
 * Inverse of `fullDayRangeToIso` — the last day the technician is actually absent, for a form
 * field or a list cell. Takes the instant one millisecond before the exclusive end rather than
 * subtracting a calendar day, so a legacy `…T23:59:59.999` end maps to the same day too.
 */
export function fullDayLastDate(endsAtIso: string): Date {
  return new Date(new Date(endsAtIso).getTime() - 1);
}
